var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['cys-avatar','cys-avatar-circle',{
    'cys-avatar-img':_vm.src,
    'cys-avatar-icon':_vm.icon
}]},[(_vm.src)?_c('img',{attrs:{"src":_vm.src}}):(_vm.icon)?_c('i',{class:['cysicon', _vm.icon]}):_c('span',{ref:"children",staticClass:"cys-avatar-string",style:(_vm.textStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a6180b90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/cys-avatar.vue
// module id = null
// module chunks = 